// extracted by mini-css-extract-plugin
export default {"section":"faq_section__Gd5V3","question":"faq_question__wM1XD","answer":"faq_answer__qAEEl"};